import { TableCellTypes } from '@carboledger/ui';
import { makeUnitTypeCell, makeUnitScopedCell, makeDiscrepanciesCell } from '@/components/common';
import { OUTGOING_SHIPMENT_STATUS_TONE } from '@/config/statusTones';
import { buildOutgoingShipmentStatusVariants } from '@/config/statuses';
import { buildRowUnitOptions } from './orderUnits';

// Order details ▸ Linked outgoing shipment tab. Discrepancies is non-interactive — the backend has no itemized detail list for a shipment row, only a count.

const renderUnitType = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));

export const buildOrderLinkedShipmentsColumns = (t, { onOpenDiscrepancy }) => [
  {
    id: 'serialNo',
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 80,
    pinnable: true,
  },
  {
    id: 'shipmentId',
    header: t('FIELD_SHIPMENT_ID'),
    type: TableCellTypes.text,
    width: 140,
    pinnable: true,
  },
  {
    id: 'status',
    header: t('FIELD_STATUS'),
    type: TableCellTypes.statusDot,
    width: 160,
    variantMap: buildOutgoingShipmentStatusVariants(t, OUTGOING_SHIPMENT_STATUS_TONE),
  },
  {
    id: 'shippingTo',
    header: t('FIELD_SHIPPING_TO'),
    type: TableCellTypes.text,
    width: 192,
  },
  {
    id: 'allocatedGhgSavings',
    header: t('ORDERS_DETAIL_COL_ALLOCATED_GHG_SAVING'),
    type: TableCellTypes.text,
    width: 220,
  },
  {
    id: 'unitType',
    header: t('UNIT_TYPE_ARIA'),
    type: TableCellTypes.custom,
    width: 252,
    cell: renderUnitType,
  },
  {
    id: 'assignedQuantity',
    header: t('ORDERS_COL_ASSIGNED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeUnitScopedCell('assignedQuantity'),
  },
  {
    id: 'shipmentQuantity',
    header: t('FIELD_SHIPMENT_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeUnitScopedCell('shipmentQuantity'),
  },
  {
    id: 'pendingQuantity',
    header: t('FIELD_PENDING_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeUnitScopedCell('pendingQuantity'),
  },
  {
    id: 'allocatedQuantity',
    header: t('FIELD_ALLOCATED_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeUnitScopedCell('allocatedQuantity'),
  },
  {
    id: 'remainingToAllocateQuantity',
    header: t('ORDERS_COL_REMAINING_TO_ALLOCATE'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeUnitScopedCell('remainingToAllocateQuantity'),
  },
  {
    id: 'tolerance',
    header: t('ORDERS_COL_TOLERANCE'),
    type: TableCellTypes.text,
    width: 140,
  },
  {
    id: 'dateOfDispatch',
    header: t('FIELD_DATE_OF_DISPATCH'),
    type: TableCellTypes.date,
    width: 150,
  },
  {
    id: 'discrepancies',
    header: t('FIELD_DISCREPANCIES'),
    type: TableCellTypes.custom,
    width: 200,
    cell: makeDiscrepanciesCell(onOpenDiscrepancy),
  },
];
